import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import './UserSettingsDialog.css';

/**
 * Configure settings for a user
 * props:
 * user
 * open: show this dialog
 * onSave: callback
 * onClose: callback
 */
class UserSettingsDialog extends React.Component {
    days = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
    debug = false;

    constructor(props) {
        super(props);

        this.createWeeklyReminder = this.createWeeklyReminder.bind(this);
        this.updateWeeklyReminder = this.updateWeeklyReminder.bind(this);
        this.deleteWeeklyReminder = this.deleteWeeklyReminder.bind(this);

        this.state = {
            edit: {
            },
        };
        if(this.debug) console.log("UserSettingsDialog:", this.props, this.state);
    }

    componentDidMount() {
        if(this.props.user && this.props.user.type && this.props.user.id) {
            // this.getUserSettings();
            this.getUserReminders();
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.user !== this.props.user && this.props.user.type && this.props.user.id) {
            // this.getUserSettings();
            this.getUserReminders();
        }
    }

    getUserSettings() {
        let user = this.props.user;
        let request = `/model/${user.type}/${user.id}`

        this.props.globals.get(request)
            .then(res => res.json())
            .then(
                (result) => {
                    if(this.debug) console.log('getUserSettings:', result);
                    // this.setState({
                    //     reminders: result.reminders,
                    // });
                },
                (error) => {
                    console.error(error);
                }
            )
    }

    getUserReminders() {
        let user = this.props.user;
        if(this.debug) console.log("UserSettingsDialog user:", user);
        if(!user) {
            this.setState({
                reminders: [],
            });
            return;
        }

        let request = `/model/${user.type}/${user.id}/reminders`

        this.props.globals.get(request)
            .then(res => res.json())
            .then(
                (result) => {
                    if(this.debug) console.log('getUserReminders:', result);
                    this.setState({
                        reminders: result,
                    });
                },
                // TODO This error handling doesn't work.
                (error) => {
                    console.error(error);
                }
            )
    }

    createWeeklyReminder() {
        let user = this.props.user;
        // let body = "The plan is nothing. The planning is everything!\n\n/Eisenhower";
        let address = window.location.href;
        let quote = "The plan is nothing. The planning is everything!";
        let quoteBy = "Eisenhower";
        let body = `<p>Make your weekly plan <a href="${address}">here.</a></p><p></p><p><i>${quote}</i></p><p>${quoteBy}.</p>`;
        let values = {
            name: "Weekly planning",
            interval: "WEEKLY",
            timeOfDay: "09:00",
            dayOfWeek: "MON",
            to: user.email,
            subject: "Time to make a plan!",
            body: body,
            encoding: "HTML",
        };

        this.props.globals.createChild(user, 'reminders', values)
            .then(res => res.json())
            .then(result => {
                if(this.debug) console.log("Result", result);
                this.getUserReminders();
            },
            error => {
                console.error(error);
            }
        );
    }

    updateWeeklyReminder(element, values) {
        let request = {...values};
        if(request.timeOfDay) {
            request.timeOfDay = request.timeOfDay + getTimezone();
        }

        this.props.globals.updateElement(element, request)
            .then(res => res.json())
            .then(result => {
                if(this.debug) console.log("Result", result);
                this.getUserReminders();
            },
            error => {
                console.error(error);
            }
        );
    }

    deleteWeeklyReminder(element) {
        if(this.debug) console.log("deleteWeeklyReminder", element);
        this.props.globals.deleteElement(element)
            .then(result => {
                if(this.debug) console.log("Result", result);
                this.getUserReminders();
            },
            (error) => {
                console.error(error);
            }
        );
    }

    render() {
        let user = this.props.user || {};
        if(this.debug) console.log("UserSettingsDialog user:", user);
        let reminders = this.state.reminders || [];
        if(this.debug) console.log("UserSettingsDialog reminders:", reminders);
        let weeklyPlanningList = reminders.filter(reminder => reminder.name === "Weekly planning");
        let weeklyPlanning = weeklyPlanningList ? weeklyPlanningList[0] : undefined;

        let column1 = 3;

        return (
            <Dialog open={this.props.open} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">User settings</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12} container className="row">
                            <Grid item xs={column1} className="label">
                                Name
                            </Grid>
                            <Grid item xs={12 - column1}>
                                {user.name}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container className="row">
                            <Grid item xs={column1} className="label">
                                Email
                            </Grid>
                            <Grid item xs={12 - column1}>
                                {user.email}
                            </Grid>
                        </Grid>

                        <Grid item xs={12} container className="row">
                            <Grid item xs={column1} className="label">
                                Weekly reminder
                            </Grid>
                            <Grid item xs={5}>
                                {weeklyPlanning ?
                                    <span>
                                        {this.state.edit.day ?
                                            <Select id="dayOfWeek"
                                                    className="select"
                                                    value={weeklyPlanning.dayOfWeek}
                                                    onChange={e => {
                                                        this.updateWeeklyReminder(weeklyPlanning, {dayOfWeek: e.target.value});
                                                        this.setState({edit: {}});
                                                    }}>
                                                {
                                                    this.days.map((day) => {
                                                        return (
                                                            <MenuItem key={day} value={day}>{day}</MenuItem>
                                                        );
                                                    })
                                                }
                                            </Select> :
                                            <span onClick={() => {
                                                this.setState({edit: {day: true}});
                                            }}>
                                                {weeklyPlanning.dayOfWeek}
                                            </span>
                                        }
                                        &nbsp;
                                        {this.state.edit.time ?
                                            <Select id="timeOfDay"
                                                    className="select"
                                                    value={removeTimezone(weeklyPlanning.timeOfDay)}
                                                    onChange={e => {
                                                        this.updateWeeklyReminder(weeklyPlanning, {timeOfDay: e.target.value});
                                                        this.setState({edit: {}});
                                                    }}>
                                                {
                                                    [...Array(24).keys()].map((hour) => {
                                                        return (
                                                            <MenuItem key={hour} value={hour + ':00'}>{hour + ':00'}</MenuItem>
                                                        );
                                                    })
                                                }
                                            </Select> :
                                            <span onClick={() => {
                                                this.setState({edit: {time: true}});
                                            }}>
                                                {removeTimezone(weeklyPlanning.timeOfDay)}
                                            </span>
                                        }
                                    </span> :
                                    "None"
                                }
                            </Grid>
                            <Grid item xs={4}>
                                {weeklyPlanning ?
                                    <Button onClick={() => this.deleteWeeklyReminder(weeklyPlanning)}>
                                        Clear
                                    </Button> :
                                    <Button onClick={this.createWeeklyReminder}>
                                        Set
                                    </Button>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    _handleTextFieldChange(e) {
        // console.log("_handleTextFieldChange", e.target.id, e.target.value);
        var newState = {};
        newState[e.target.id] = e.target.value;
        this.setState(newState);
    }
}

function pad(number, length) {
    var str = "" + number
    while (str.length < length) {
        str = '0'+str
    }
    return str
}

function getTimezone() {
    var offset = new Date().getTimezoneOffset()
    return ((offset < 0 ? '+' : '-') +
        pad(parseInt(Math.abs(offset / 60)), 2) +
        pad(Math.abs(offset % 60), 2));
}

function removeTimezone(time) {
    // console.log("removeTimezone", time);
    let ix = time.indexOf('+');
    if(ix < 0) {
        ix = time.indexOf('-');
    }
    // console.log("removeTimezone: ix=", ix);
    if(ix >= 0) {
        // console.log("removeTimezone: return substring", time.substring(0, ix));
        return time.substring(0, ix);
    } else {
        return time;
    }
}

export default UserSettingsDialog;
